import { ChangeEvent } from 'react';

type SanitizeOptions = {
  allowDecimal?: boolean;
};

export function sanitizeNumericInput(
  e: ChangeEvent<HTMLInputElement>,
  onChange: (value: string) => void,
  options: SanitizeOptions = {},
) {
  const { allowDecimal = false } = options;
  const regex = allowDecimal ? /[^0-9.]/g : /[^0-9]/g;
  let value = e.target.value.replace(regex, '');

  if (allowDecimal) {
    const parts = value.split('.');
    value = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : value;
  }

  onChange(value);
}
